import {
  FETCH_PAYMENTS_REQUEST,
  FETCH_PAYMENTS_SUCCESS,
  FETCH_PAYMENTS_FAILURE,
  FETCH_MY_PAYMENTS_REQUEST,
  FETCH_MY_PAYMENTS_SUCCESS,
  FETCH_MY_PAYMENTS_FAILURE,
  INITIATE_PAYMENT_REQUEST,
  INITIATE_PAYMENT_SUCCESS,
  INITIATE_PAYMENT_FAILURE,
} from "../actions/paymentActionTypes";

const initialState = {
  loading: false,
  payments: [],
  myPayments: [],
  initiatedPayment: null, // ✅ stores result of latest payment initiation
  error: null,
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch All Payments
    case FETCH_PAYMENTS_REQUEST:
    case FETCH_MY_PAYMENTS_REQUEST:
    case INITIATE_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        payments: action.payload,
      };

    case FETCH_MY_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        myPayments: action.payload,
      };

    case INITIATE_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        initiatedPayment: action.payload,
      };

    case FETCH_PAYMENTS_FAILURE:
    case FETCH_MY_PAYMENTS_FAILURE:
    case INITIATE_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default paymentReducer;
